export default function Top({ title, subTitle }) {
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-8d8ca34 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
      data-id="8d8ca34"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e119795"
          data-id="e119795"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-e6bb1f7 elementor-widget elementor-widget-heading"
              data-id="e6bb1f7"
              data-element_type="widget"
              data-widget_type="heading.default"
            >
              <div className="elementor-widget-container">
                <h1 className="elementor-heading-title elementor-size-default">
                  {title}
                </h1>
              </div>
            </div>
            <div
              className="elementor-element elementor-element-7a3aabb elementor-widget elementor-widget-text-editor"
              data-id="7a3aabb"
              data-element_type="widget"
              data-widget_type="text-editor.default"
            >
              <div className="elementor-widget-container">{subTitle}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
